import { render, staticRenderFns } from "./PaymentWrapper.vue?vue&type=template&id=654ea360&scoped=true&"
import script from "./PaymentWrapper.vue?vue&type=script&lang=js&"
export * from "./PaymentWrapper.vue?vue&type=script&lang=js&"
import style0 from "./PaymentWrapper.vue?vue&type=style&index=0&id=654ea360&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654ea360",
  null
  
)

export default component.exports